export default {
      id: "icon-triangle-usage",
      viewBox: "0 0 10 10",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-triangle",
      toString: function () {
        return this.url;
      }
    }